export const FILE_PATH = `https://${process.env.REACT_APP_IMAGE_UPLOAD_BUCKET}.s3.${process.env.REACT_APP_REGION}.amazonaws.com`;

export const createFile = (fileUrl: string) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', 'products-filter.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
};
